import featureFlag from './feature-flag';
import dragScroll from './drag-scroll';

const directives = {
	'feature-flag': featureFlag,
	'drag-scroll': dragScroll
};

export const registerDirectives = (app) => {
	Object.keys(directives).forEach((key) => {
		app.directive(key, directives[key]);
	});
};
